import infrastructures from "./infrastructures";
import Http from "@adapters/infrastructures/Http";
import Authorizer from "@adapters/infrastructures/Authorizer";
import { AccountDetails } from "@domains/utils/AccountDetails";
import CommonQuotesHomePageRepository from "@adapters/repositories/Common/QuotesPageRepository";
import { GTMServiceClass } from "@domains/trackers/gtmService";
export var cInfrastructures = infrastructures();
export var accountDetails = new AccountDetails(cInfrastructures.localStorage, cInfrastructures.cookieStorage, cInfrastructures.sessionStorage);
export var GTMService = new GTMServiceClass(cInfrastructures.localStorage);
export var autorize = new Authorizer(cInfrastructures.localStorage, cInfrastructures.cookieStorage, cInfrastructures.sessionStorage);
export var http = new Http(autorize, cInfrastructures.localStorage);
//export const salesHttp = new SalesHttp(autorize, cInfrastructures.sessionStorage);
export var commonQuotesHomePageRepository = new CommonQuotesHomePageRepository(http);
